export default "assets/images/logo-2fdd279d.png";